import { Link, useLocation } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Users, 
  FileText, 
  Briefcase, 
  Mail, 
  FileEdit,
  FolderOpen,
  LogOut,
  Menu,
  X,
  Upload
} from 'lucide-react';
import { useState } from 'react';

const LeftSidebar = ({ user, onLogout }) => {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);

  const menuItems = [
    { path: '/dashboard', icon: LayoutDashboard, label: 'Dashboard', roles: ['all'] },
    { path: '/admin', icon: Users, label: 'User Management', roles: ['admin'] },
    { path: '/case-filing', icon: FileText, label: 'Case Filing', roles: ['admin'] },
    { path: '/cases', icon: Briefcase, label: 'Cases', roles: ['all'] },
    { path: '/notice-templates', icon: FileEdit, label: 'Notice Templates', roles: ['admin'] },
    { path: '/bulk-upload', icon: Upload, label: 'Bulk Doc Upload', roles: ['admin'] },
  ];

  const filteredMenu = menuItems.filter(item => 
    item.roles.includes('all') || item.roles.includes(user?.role)
  );

  return (
    <div 
      className={`sidebar ${collapsed ? 'collapsed' : ''}`}
      style={{
        width: collapsed ? '70px' : '260px',
        height: '100vh',
        background: '#1a202c',
        position: 'fixed',
        left: 0,
        top: 0,
        transition: 'width 0.3s',
        display: 'flex',
        flexDirection: 'column',
        zIndex: 1000
      }}
    >
      <div style={{ padding: '1.5rem', borderBottom: '1px solid #2d3748' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          {!collapsed && (
            <h1 style={{ color: '#667eea', fontSize: '1.25rem', fontWeight: 700, margin: 0 }}>
              Samanvay ODR
            </h1>
          )}
          <button
            data-testid="toggle-sidebar"
            onClick={() => setCollapsed(!collapsed)}
            style={{
              background: 'transparent',
              border: 'none',
              color: '#cbd5e0',
              cursor: 'pointer',
              padding: '0.5rem'
            }}
          >
            {collapsed ? <Menu size={20} /> : <X size={20} />}
          </button>
        </div>
      </div>

      <nav style={{ flex: 1, padding: '1rem 0', overflowY: 'auto' }}>
        {filteredMenu.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          
          return (
            <Link
              key={item.path}
              to={item.path}
              data-testid={`nav-${item.label.toLowerCase().replace(' ', '-')}`}
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: collapsed ? '0.875rem 1.25rem' : '0.875rem 1.5rem',
                color: isActive ? '#667eea' : '#cbd5e0',
                textDecoration: 'none',
                background: isActive ? 'rgba(102, 126, 234, 0.1)' : 'transparent',
                borderLeft: isActive ? '3px solid #667eea' : '3px solid transparent',
                marginBottom: '0.25rem',
                transition: 'all 0.2s',
                fontSize: '0.95rem',
                fontWeight: isActive ? 600 : 400
              }}
              onMouseEnter={(e) => {
                if (!isActive) {
                  e.currentTarget.style.background = 'rgba(203, 213, 224, 0.1)';
                  e.currentTarget.style.color = '#e2e8f0';
                }
              }}
              onMouseLeave={(e) => {
                if (!isActive) {
                  e.currentTarget.style.background = 'transparent';
                  e.currentTarget.style.color = '#cbd5e0';
                }
              }}
            >
              <Icon size={20} style={{ minWidth: '20px' }} />
              {!collapsed && (
                <span style={{ marginLeft: '1rem' }}>{item.label}</span>
              )}
            </Link>
          );
        })}
      </nav>

      <div style={{ padding: '1rem', borderTop: '1px solid #2d3748' }}>
        <div style={{ 
          padding: collapsed ? '0.75rem' : '0.75rem 1rem', 
          background: '#2d3748',
          borderRadius: '8px',
          marginBottom: '0.75rem'
        }}>
          {!collapsed && (
            <>
              <div style={{ color: '#e2e8f0', fontSize: '0.875rem', fontWeight: 600, marginBottom: '0.25rem' }}>
                {user?.name || user?.phone}
              </div>
              <div style={{ color: '#a0aec0', fontSize: '0.75rem' }}>
                {user?.role?.replace('_', ' ').toUpperCase()}
              </div>
            </>
          )}
          {collapsed && (
            <div style={{ color: '#667eea', fontSize: '1rem', fontWeight: 700, textAlign: 'center' }}>
              {user?.name?.charAt(0) || 'U'}
            </div>
          )}
        </div>
        <button
          data-testid="sidebar-logout"
          onClick={onLogout}
          style={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: collapsed ? 'center' : 'flex-start',
            padding: '0.75rem 1rem',
            background: '#fc8181',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '0.875rem',
            fontWeight: 600,
            transition: 'background 0.2s'
          }}
          onMouseEnter={(e) => e.currentTarget.style.background = '#f56565'}
          onMouseLeave={(e) => e.currentTarget.style.background = '#fc8181'}
        >
          <LogOut size={18} />
          {!collapsed && <span style={{ marginLeft: '0.75rem' }}>Logout</span>}
        </button>
      </div>
    </div>
  );
};

export default LeftSidebar;
